import queryKeys from '@/constants/queryKeys';
import { createContent } from '@/services/api/requests/content';
import { TCreateContentPayload } from '@/types/Content.types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

// No toast/navigation here — the create flow chains image uploads and an optional
// publish before reporting success, so the caller orchestrates those via mutateAsync.
const useCreateContent = () => {
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation({
    mutationFn: async (payload: TCreateContentPayload) => createContent(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.content.mine] });
    },
  });

  return { isPending, mutateAsync };
};

export default useCreateContent;
